import React from 'react';
const ProgressBar = ({ bgcolor, completed }) => {
    const wrapperStyles = {
        display: 'flex',
        alignItems: 'center',
        margin: '47px 0',
        gap: '10px',
    };

    const containerStyles = {
        width: "275px",
        height: "16px",
        backgroundColor: '#E3E3E3',
        borderRadius: 50,
    };

    const fillerStyles = {
        height: '100%',
        width: `${completed}%`,
        backgroundColor: bgcolor,
        borderRadius: 'inherit',
        transition: 'width 0.3s ease-in-out',
    };

    const labelStyles = {
        fontFamily: 'IBM Plex Sans',
        fontWeight: 600,
        fontSize: '18px',
        lineHeight: '21px',
    };

    return (
        <div style={wrapperStyles}>
            <div style={containerStyles}>
                <div style={fillerStyles}></div>
            </div>
            <span style={labelStyles}>{`${completed}% Complete`}</span>
        </div>
    );
};
export default ProgressBar;